import { module } from 'modujs';
import { $html } from '../utils/dom';

export default class Header extends module {
    static get settings() {
        return {
            CLASS_STICKY: 'is-sticky'
        }
    }

    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el
        this.$sticky = this.$('sticky')[0]

        // Vars
        this.isSticky = false
        this.stickyIsLocked = false
        this.scrollTop = true

        this.events = {
            click: {
                "menu-toggler": "onMenuClick",
            }
        }
    }

    onMenuClick() {
        this.call('open', null, 'Menu')
    }
}